import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#8DC7E9' : props.fill;
  const width = !size && !props.width ? 120 : props.width;
  const height = !size && !props.height ? 28 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 120 28"
      >
        <defs>
          <filter colorInterpolationFilters="auto" id="a">
            <feColorMatrix
              in="SourceGraphic"
              values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
            />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(33.723508 5.273548)" filter="url(#a)">
            <path
              d="M84.1112079 2.78446923v.52466446h.3710128c.2698274 0 .3934983-.08994248.3934983-.26233223 0-.20986578-.1761373-.25858462-.4159839-.25858462h-.3485272v-.00374761zm.378508.75701587h-.378508v.63709255h-.2402213V2.54087502h.4950584c.4759456 0 .7678839.07495207.7678839.49843124 0 .18363256-.0970629.35976991-.3069287.44596479l.3747603.69705421h-.2773226l-.3410319-.64084016h-.0936901zm1.2591947-.13116612c0-.79449189-.5512725-1.32665156-1.2929232-1.32665156-.7274097 0-1.2966707.53215967-1.2966707 1.32665156 0 .78699669.569261 1.32290396 1.2966707 1.32290396.7382779 0 1.2929232-.53590727 1.2929232-1.32290396zm.2510894 0c0 .9181628-.6936814 1.54401255-1.5440126 1.54401255-.8582011 0-1.5477601-.62584975-1.5477601-1.54401255s.6933066-1.54776015 1.5477601-1.54776015C85.3063186 1.86255883 86 2.49215618 86 3.41031898zM71.5867178 20.2295625h.8619488c1.217971 0 1.8172128-.0712045 2.4846609-1.8663064l.4047412-1.0268433L70.413718 4.47463831h1.6751786l3.9908228 10.80808789 3.8712742-10.80808789h1.6006013L76.2670995 18.6293359c-.90692 2.484661-1.5286473 2.8931497-3.8484138 2.8931497h-.8360903v-1.2929231h.0041224zM68.9821335.0037476h1.0527018v1.3641276h-.7416507c-1.6264598 0-1.8179624.14240892-1.8179624 1.7201499v1.38661321h2.5596131v1.28917553h-2.5596131V17.3364128h-1.4840509V5.76381384h-1.7684939V4.47463831h1.7684939v-1.6039742c0-2.10240544.5512725-2.8669165 2.9909622-2.8669165zm-8.4171169 17.3326652h1.4840509V4.47463831h-1.4840509V17.3364128zm0-14.96792753h1.4840509V.0037476h-1.4840509v2.36473767zM56.498867 8.60824473c-.4796932-1.9375109-2.0087154-2.98683981-3.8712742-2.98683981-2.2223287 0-4.1860728 1.76886874-4.1860728 5.30660628 0 3.6576608 1.9599965 5.3556998 4.2085584 5.3556998 2.1998432 0 3.5864564-1.4094736 3.9462263-3.0134478h1.577741c-.5246645 2.6536779-2.6795364 4.3772006-5.5239673 4.3772006-3.6576608 0-5.7866742-2.7245076-5.7866742-6.6932194 0-3.99119751 2.1514991-6.69321947 5.9065975-6.69321947 2.9152606 0 4.9018651 2.03120097 5.2841207 4.3509674H56.498867v-.0037476zM43.7079223 10.9504968c0-3.68014644-1.7909796-5.33283949-4.2569026-5.33283949s-4.2310441 1.64894544-4.2310441 5.33283949c0 3.6801464 1.7688687 5.3332142 4.2310441 5.3332142 2.4618006 0 4.2569026-1.6493202 4.2569026-5.3332142zm1.5777409 0c0 4.6845041-2.750366 6.6932194-5.8346435 6.6932194-3.0842775 0-5.8087851-2.0087153-5.8087851-6.6932194 0-4.68450412 2.7245076-6.69321948 5.8087851-6.69321948s5.8346435 2.00871536 5.8346435 6.69321948zm-15.7058305 6.385916h1.4840509V.0037476h-1.4840509v17.3326652zm-4.2085585-7.36404048c0-2.1773575-1.5552554-4.37345302-4.137354-4.37345302-2.3909709 0-4.1111208 1.52902213-4.4221719 4.37345302h8.5595259zm-4.1148684-5.715095c3.6351752 0 5.9287084 3.06179188 5.7375806 7.07584978H16.7630295c.0487188 3.1063883 2.0087153 4.9505839 4.6395328 4.9505839 2.0087154 0 3.4178142-1.0272181 3.919993-2.795712h1.5552554c-.6221021 2.6529283-2.7507408 4.1594648-5.5689385 4.1594648-3.7775841 0-6.0711213-2.7020219-6.0711213-6.6932194-.0037436-4.16358726 2.5783551-6.69696708 6.0186549-6.69696708zM7.22163151 15.350183L12.5769566 0h1.7201499L8.08358027 17.3364128H6.24350706L0 .0037476h1.76886875L7.22163151 15.350183z"
              fill="#353C46"
            />
          </g>
          <path
            d="M23.896875 2l-6.358125 8.930625H24V2h-.103125zM0 2v24h10.445625L14.3925 13.65125h-7.455L13.3558125 2H0zm11.35875 24H24V12.029375L11.35875 26z"
            fill="#8DC7E9"
          />
        </g>
      </svg>
    </span>
  );
};

export default SvgIcon;
